import { render } from "./DetailRow.vue?vue&type=template&id=6036640e&scoped=true"
import script from "./DetailRow.vue?vue&type=script&lang=js"
export * from "./DetailRow.vue?vue&type=script&lang=js"

import "./DetailRow.vue?vue&type=style&index=0&id=6036640e&scoped=true&lang=css"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6036640e"],['__file',"resources/js/Pages/PurchaseReqs/DetailRow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6036640e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6036640e', __exports__)) {
    console.log('reload')
    api.reload('6036640e', __exports__)
  }
  
  module.hot.accept("./DetailRow.vue?vue&type=template&id=6036640e&scoped=true", () => {
    console.log('re-render')
    api.rerender('6036640e', render)
  })

}


export default __exports__